document.addEventListener('DOMContentLoaded', () => {
  const modalDownloadEl = document.getElementById('download-app')
  if (modalDownloadEl) {
    // lock body scroll while "Download app" modal is open
    modalDownloadEl.addEventListener('shown.bs.modal', () => document.body.classList.add('lock-body-scroll'))
    modalDownloadEl.addEventListener('hidden.bs.modal', () => document.body.classList.remove('lock-body-scroll'))
  }
})
